var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-2",attrs:{"fluid":""}},[_c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('SideNav',{on:{"on-tab-change":_vm.tabChanged}})],1),_c('v-col',[_c('Content',{attrs:{"current-tab":_vm.currentTab}})],1)],1)],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }